import Reflux from 'reflux';
import { actions } from 'actions';


var CountryStore = Reflux.createStore({
  init: function() {
    this.listenTo(actions.getCountries, this.getCountries);
  },
  getCountries: function() {
    fetch('/rest/v2/supplier/countries').then((response) => {
      return response.json();
    }).then(data => {
      this.trigger(data);
    });
  }
})

export { CountryStore };
